var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { accountDetails } from "../../../../../../mainDi/webDi";
import di from "@frameworks/web/components/features/TOC/di/servicelocator";
import { TOCProductCode, TOCOrderType, TOCBUYORSELL, TOCValidationCode, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import { eqOrder, eqProducts } from "./EqConstants";
export var setUISections = function (activeButton, isFNO) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (isFNO === void 0) { isFNO = false; }
    var tempShowUiSections = {
        showStopLoss: false,
        showTargetPrice: false,
        showTriggerPrice: false,
        showTermsConditions: false,
        disabledLimitInput: false,
    };
    if ((((_a = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === TOCProductCode.CNC ||
        ((_b = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === TOCProductCode.MIS) &&
        ((_c = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === TOCOrderType.MARKET)
        tempShowUiSections.disabledLimitInput = true;
    if (((_d = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === TOCProductCode.BO &&
        ((_e = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showTargetPrice = true;
        tempShowUiSections.showTermsConditions = true;
    }
    if (isFNO &&
        (((_f = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === TOCProductCode.NRML ||
            ((_g = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _g === void 0 ? void 0 : _g.includes("NRML"))) &&
        ((_h = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === TOCOrderType.MARKET)
        tempShowUiSections.disabledLimitInput = true;
    if (
    // (activeButton?.PRODUCT?.toUpperCase() === TOCProductCode.NRML ||
    //   activeButton?.PRODUCT?.toUpperCase() === TOCProductCode.CNC) &&
    ((_j = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === TOCOrderType.SL) {
        tempShowUiSections.showTriggerPrice = true;
    }
    if (((_k = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === TOCProductCode.BO &&
        ((_l = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _l === void 0 ? void 0 : _l.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showStopLoss = true;
    }
    return tempShowUiSections;
};
export var AuthToSellJourney = function (activeButton, activeState) {
    return {
        shouldGoTOAuth: function (rmsDetails) { return __awaiter(void 0, void 0, void 0, function () {
            var isPOA;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, accountDetails.isNonPoaClient()];
                    case 1:
                        isPOA = _a.sent();
                        return [2 /*return*/, (activeState === TOCBUYORSELL.SELL &&
                                isPOA &&
                                // activeButton.ORDER === eqOrder[0].title &&
                                activeButton.PRODUCT === eqProducts[0].title &&
                                rmsDetails.rmsHolding.sts != "Success"
                            // (rmsDetails.rmsHolding.sts == "Ok" ||
                            //   rmsDetails.rmsHolding.sts == "Pending")
                            )];
                }
            });
        }); },
        authMessage: function (rmsDetails) {
            var _a, _b;
            if (activeState === TOCBUYORSELL.SELL &&
                // activeButton.ORDER === eqOrder[0].title &&
                activeButton.PRODUCT === eqProducts[0].title) {
                if (!rmsDetails.rmsHoldingLoader &&
                    !rmsDetails.rmsHoldingErrorData.isOpen) {
                    if (rmsDetails.rmsHolding.authorize != false &&
                        rmsDetails.rmsHolding.sts == "Pending")
                        return "You already have a pending authorization request. Please complete it before authorizing again";
                    else if (rmsDetails.rmsHolding.authorize != false &&
                        rmsDetails.rmsHolding.sts == "Complete")
                        return "We will notify you and the client, once the holdings are updated and available for sell. This usually takes around 15-20 mins";
                    else if (rmsDetails.rmsHolding.authorize == false &&
                        rmsDetails.rmsHolding.sts != "Success") {
                        return (_a = rmsDetails === null || rmsDetails === void 0 ? void 0 : rmsDetails.rmsHolding) === null || _a === void 0 ? void 0 : _a.msg;
                    }
                }
                else if (!rmsDetails.rmsHoldingLoader &&
                    rmsDetails.rmsHoldingErrorData.isOpen) {
                    var errMsg = (_b = rmsDetails.rmsHoldingErrorData.error) === null || _b === void 0 ? void 0 : _b.getHttpCode();
                    if (errMsg === 222)
                        return "";
                    return rmsDetails.rmsHoldingErrorData.error.getErrMsg();
                }
            }
        },
        PostCDSLRedirection: function () {
            return localStorage.getItem("AuthToSellSymbol");
        },
        multiquote: function (location, symbol) {
            // if (location && location.state)
            di.tocJourney.getMultiQuoteData({
                symLst: [symbol],
            });
        },
        disableSell: function (rmsDetails) { return __awaiter(void 0, void 0, void 0, function () {
            var isPOA;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, accountDetails.isNonPoaClient()];
                    case 1:
                        isPOA = _c.sent();
                        if ((_a = rmsDetails === null || rmsDetails === void 0 ? void 0 : rmsDetails.rmsHolding) === null || _a === void 0 ? void 0 : _a.sts) {
                            return [2 /*return*/, (activeState === TOCBUYORSELL.SELL &&
                                    isPOA &&
                                    activeButton.ORDER === eqOrder[0].title &&
                                    activeButton.PRODUCT === eqProducts[0].title &&
                                    ((_b = rmsDetails === null || rmsDetails === void 0 ? void 0 : rmsDetails.rmsHolding) === null || _b === void 0 ? void 0 : _b.sts) !== "Success")];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
    };
};
export var setUISectionsEquity = function (activeButton, isFNO) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    if (isFNO === void 0) { isFNO = false; }
    var tempShowUiSections = {
        showStopLoss: false,
        showTargetPrice: false,
        showTriggerPrice: false,
        showTermsConditions: false,
        disabledLimitInput: false,
        discloseQty: false,
    };
    if ((((_a = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === TOCProductCode.CNC ||
        ((_b = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === TOCProductCode.MIS ||
        ((_c = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === TOCProductCode.NRML ||
        ((_d = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === TOCProductCode.MTF) &&
        (((_e = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === TOCOrderType.MARKET ||
            ((_f = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === TOCOrderType.LIMIT)) {
        if (((_g = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === TOCOrderType.MARKET) {
            tempShowUiSections.disabledLimitInput = true;
        }
        if (((_h = activeButton === null || activeButton === void 0 ? void 0 : activeButton.VALIDITY) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === TOCValidationCode.DAY) {
            tempShowUiSections.discloseQty = true;
        }
    }
    if ((((_j = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === TOCProductCode.CNC ||
        ((_k = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === TOCProductCode.MIS ||
        ((_l = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _l === void 0 ? void 0 : _l.toUpperCase()) === TOCProductCode.MTF ||
        ((_m = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _m === void 0 ? void 0 : _m.toUpperCase()) === TOCProductCode.NRML) &&
        ((_o = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _o === void 0 ? void 0 : _o.toUpperCase()) === TOCOrderType.SL) {
        tempShowUiSections.showTriggerPrice = true;
    }
    if (((_p = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _p === void 0 ? void 0 : _p.toUpperCase()) === TOCProductCode.BO &&
        ((_q = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _q === void 0 ? void 0 : _q.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showTargetPrice = true;
        tempShowUiSections.showStopLoss = true;
        tempShowUiSections.showTermsConditions = true;
        tempShowUiSections.discloseQty = false;
    }
    return tempShowUiSections;
};
